<template>
    <span/>
</template>

<script>
const { SvgConstants } = require("../../config/config");
const projects = require("../../projects.js");
const { mapState } = require("vuex");

export default {
name: "project-area-overlay",
    props: ["transcriptHook", "svgNode", "svgRoot", "textSvg"],

    computed: {
        ...mapState("transcript", ["displayProjectAreas", "eventBus"])
    },

    methods: {
        toggleProjectAreaDisplay() {
            if(this.displayProjectAreas) {
                for (const proj of document.querySelectorAll(".projectareas .project")) {
                    proj?.classList?.add("active");
                }
            }
            else
            {
                for (const proj of document.querySelectorAll(".projectareas .project")) {
                    proj?.classList?.remove("active");
                }
            }
        }
    },

    watch: {
        displayProjectAreas: function() {
            this.toggleProjectAreaDisplay();
        }
    },

    mounted() {
        this.eventBus.$on('facsimile-open', () => {
            if(this.svgRoot()) {
                setupProjectAreaOverlay(this.svgRoot());
                this.toggleProjectAreaDisplay();
            }
        })
    },

    beforeDestroy() {
        this.eventBus.$off('facsimile-open')
    }
}

function setupProjectAreaOverlay(svgRoot) {
    if(!svgRoot) {
        return;
    }
    console.log("setting up project area overlay")
    const pa = document.querySelector("g .projectareas");
    if(pa) {
        svgRoot.prepend(pa);// move project area overlay to correct position
        const projectElements = pa.querySelectorAll(".project");
        projectElements.forEach((element) => {
            // get text position from frame size
            const rect = element.querySelector("rect");
            const x = Number(rect.getAttribute("x")) + Number(rect.getAttribute("width")) + 25;
            const y = Number(rect.getAttribute("y")) + Number(rect.getAttribute("height")) / 2;
            let text = element.getAttribute("id").substring(0, element.getAttribute("id").indexOf("-"));
            if(projects()[text]) {
                text = projects()[text];
            }
            const newTextNode = document.createElementNS(SvgConstants.NS, "text");
            newTextNode.setAttribute("x", x);
            newTextNode.setAttribute("y", y);
            newTextNode.append(text);
            element.append(newTextNode);
        });
    }
}
</script>